import Vue from 'vue'
import Router from 'vue-router'
import BasicInfo from '@/views/forms/BasicInfo.vue'
import AdvancedInfo from '@/views/forms/AdvancedInfo.vue'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'home',
			component: BasicInfo
		},
		{
			path: '/basic/:filename',
			name: 'advanced',
			component: BasicInfo,
			meta: {
				advanced: true
			}
		},
		{
			path: '/:filename',
			name: 'advanced',
			component: AdvancedInfo,
			meta: {
				advanced: true
			}
		}
	]
})
